<template>
  <div>
    <div class="columns is-multiline">
      <div style="padding: 1em;">
        <p class="title is-4 rotate" style="margin-bottom: .5em;">Filter Register by Service Offered:</p>
        <ul class="serviceFilter">
          <li
            style="padding: .25em .5em; margin: 2px; line-height: 2.5em; display:inline-block; -webkit-column-break-inside: avoid; page-break-inside: avoid; break-inside: avoid;"
            v-for="(service, index) in serviceList" @click="toggleService(index, service.title, !service.active)"
            :class="{'active':service.active}">{{ service.title }}</li>
          <!-- @click="service.active=!service.active" -->
        </ul>
      </div>
      <div style="padding: 1em;">
        <p class="title is-4 rotate" style="margin-bottom: .5em;">Region:</p>
        <ul class="serviceFilter">
          <li
            style="padding: .5em; margin: 2px; line-height: 2.5em; display:inline-block; -webkit-column-break-inside: avoid; page-break-inside: avoid; break-inside: avoid;"
            @click="local=!local" :class="{'active':local}">Local to Council Area</li>
        </ul>
      </div>
    </div>

    <div class="columns is-multiline">
      <div v-if="filteredPeople.length == 0">
        <div class="column">
          <p class="is-size-4" style="padding: .5em;">Sorry no results, please adjust your search criteria!</p>
        </div>
      </div>

      <template v-for="(item, index) in filteredPeople">
        <div class="column is-one-quarter">
          <div class="card-image">
            <figure class="image is-4by3">
              <a @click="item.descriptionModal = true">
                <img :src="'/images/ATSI/'+item.photo" :alt="'Photo of '+item.name">
              </a>
            </figure>
          </div>
          <div class="card-content">
            <div class="media">
              <div class="media-content">
                <p class="title">
                  <a @click.prevent="item.descriptionModal = true">{{ item.name }}</a>
                </p>
              </div>
            </div>
          </div>

          <div v-if="item.description" class="modal" v-bind:class="{'is-active' : item.descriptionModal}">
            <div class="modal-background"></div>
            <div class="modal-content">
              <div class="notification is-light has-text-left">
                <button class="delete" @click="item.descriptionModal = false"></button>

                <div class="columns">
                  <div class="column is-three-quarters">
                    <p class="title is-4 is-marginless">
                      <strong>{{ item.name }}</strong>
                    </p>
                    <div v-html="item.description" style="margin-top:1em;"></div>
                    <h3 v-if="item.email || item.contactNumbers" class="is-size-5"
                      style="margin-bottom: .25em; margin-top: 1em;">
                      <strong>Contact Details</strong>
                    </h3>
                    <p v-if="item.website">
                      <a target="_blank" :href="item.website">{{ item.website }}</a>
                    </p>
                    <p v-if="item.email">
                      <a :href="'mailto:'+item.email">{{ item.email }}</a>
                    </p>
                    <ul v-for="contact in item.contactNumbers" class="is-size-6">
                      <li>{{ contact }}</li>
                    </ul>
                    <br>
                  </div>

                  <div class="column is-one-quarter">
                    <img :src="'/images/ATSI/'+item.photo" :alt="'Photo of '+item.name">

                    <h3 v-if="item.services" class="is-size-5" style="margin-bottom: .25em; margin-top: 1em;">
                      <strong>Services</strong>
                    </h3>
                    <ul>
                      <li v-for="service in item.services"
                        style="background: #000; color: #fff; padding: .5em; margin: .15em;">{{ service }}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <button class="modal-close is-large" aria-label="close" @click="item.descriptionModal = false"></button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
  var Vue = require("vue");

export default {
  components: {},

  watch: {},

  methods: {
    toggleService: function(index, title, active) {
      if (active) {
        this.serviceFilter.push(title);
      } else {
        this.serviceFilter.splice(this.serviceFilter.indexOf(title), 1);
      }

      Vue.set(this.serviceList, index, { active: active, title: title });
    }
  },

  computed: {
    filteredPeople() {
      let items = this.items;
      items = items.filter(p => {
        var i;

        if (this.local) {
          if (!p.local) {
            return false;
          }
        }

        for (i = 0; i < this.serviceFilter.length; i++) {
          if (p.services.indexOf(this.serviceFilter[i]) > -1) {
          } else {
            return false;
          }
        }

        return true;
      });

      return items;
    }
  },

  data() {
    return {
      searchTasks: [],
      serviceList: [
        { title: "Welcome to Country", active: false },
        { title: "Greetings to Country", active: false },
        { title: "Smoking Ceremony", active: false },
        { title: "Kaurna Language", active: false },
        { title: "Cultural Education", active: false },
        { title: "Cultural Tours", active: false },
        { title: "Cultural Dance", active: false },
        { title: "Cultural Producer", active: false },
        { title: "Aboriginal Artist", active: false },
        { title: "Cross-Cultural Consultancy", active: false },
        { title: "Didgeridoo", active: false },
        { title: "Narrative Therapy", active: false },
        { title: "Leaf Ceremony", active: false },
        { title: "Visual Artist", active: false },
        { title: "Traditional Clothing", active: false }
      ],
      serviceFilter: [
        //'Aboriginal Art',
        //'Cross-cultural Consultancy',
        //'Cultural Dance',
        //'Cultural Education',
        //'Cultural Tours',
        //'Didgeridoo',
        //'Greetings to Country',
        //'Leaf Ceremony'
        //'Narrative Therapy',
        //'Smoking Ceremony',
        //'Welcome to Country'
      ],
      local: false,
      items: [

        {
          name: "Margaret Brodie",
          photo: "margaret_brodie.png",
          services: ["Cultural Tours", "Welcome to Country"],
          local: true,
          contactNumbers: ["0478 664519"],
          email: "magbrodie@gmail.com",
          website: null,
          descriptionModal: false,
          description:
            "<p>Margaret Brodie is a Proud Kaurna woman from the Port Adelaide Area.</p>She is a certified tour guide and has done several tours around the Port Adelaide areas since 1996.</p><p>Margaret has a very close connection to the Port River regarding ties to the Lartelare park.</p><br/><blockquote><p><q>I am because of her… Lartelare...the culture and the connection is important because it is who we are.</q></p></blockquote><br/>"
        },
        {
          name: 'Karl "Winda" Telfer',
          photo: "karl_telfer.png",
          services: [
            "Welcome to Country",
            "Greetings to Country",
            "Smoking Ceremony",
            "Cross-Cultural Consultancy",
            "Cultural Education",
            "Cultural Tours",
            "Cultural Dance",
            "Visual Artist",
            "Cultural Producer",
            "Cultural Ceremony",
            "Didgeridoo",
            "Traditional Clothing"
          ],
          local: false,
          contactNumbers: ["0417 835805"],
          email: "winda8@yahoo.com",
          website: "credadl.com",
          descriptionModal: false,
          description:
            "<ul><li>Karl `Winda` Telfer - Senior Kaurna Custodian of Ceremony</li><li>Senior Custodian of the Tjirbruki Peace Lore Fire - Dreaming Track</li><li>Mullawirra/Kudnarto/Wari - Tribal clans</li><li>Williams Family Clan of the Kaurna Nation</li></ul><ul><li>Greetings to Country</li><li>Cultural Ceremony - Cleansing and Smoking ceremonies</li><li>YELLAKA - `Old Wisdom - New Ways` Cultural Dance Group</li><li>Cultural Education Programs/Lectures</li><li>Cultural Ways of Understanding awareness workshops - `Ways of Understanding`</li><li>Cultural Tours - Adelaide Plains - Coastal/River country to Tarndanyangga (Adelaide CBD).</li><li>Tjirbruki Dreaming Track - Story and cultural sharing/songlines</li><li>Cultural Mapping Research</li><li>Integrated Cultural Designer</li><li>Cultural Producer/Cultural projection and Animation</li><li>Visual Artist</li><li>Yidaki (didgeridoo)</li><li>Language Activism</li></ul><p>Karl Has been practising culture on his country for 25 years and holds extensive knowledge of his country/culture/history and story.</p><br/>"
        },
        {
          name: "Mickey Kumatpi Marrutya O`Brien",
          photo: "michael_obrien.jpg",
          services: [
            "Welcome to Country",
            "Leaf Ceremony",
            "Smoking Ceremony",
            "Cross-Cultural Consultancy",
            "Cultural Education",
            "Traditional Clothing"
          ],
          local: true,
          contactNumbers: ["0401 126163"],
          email: "mob@bigpond.com",
          website: null,
          descriptionModal: false,
          description:
            '<p>Mickey Kumatpi Marrutya O`Brien is a Senior Aboriginal Man a descendant of the Kaurna (Adelaide Plains) and Narrunga (York Peninsula) peoples.</p><p>He has been, sharing cultural engagement for a number of years; a role handed to Michael by his Father, Uncle Lewis Yerla Burka O’Brien. It is a position, he honours and respects greatly.</p><p>Mickey enjoys sharing Cultural Knowledge and providing Welcome to Country, with people, not at people and enjoys opportunities to support the Aboriginal Community.</p><p>Travelling across Australia, living and working in a number of Aboriginal Communities Mickey has delivered programs, sat on boards and Advisory Panels.</p><p>He is a recipient of the Rotary Club Courtesy Award, for Community involvement working with youth. He is also an Australia Day Service Award recipient, and is a Foster Parent of sixteen years, to three beautiful children.</p><br/><blockquote><p><q>My Father has told me, Aboriginal people have always welcomed people to this country, we just never told them to go home.</q></p></blockquote><br/><small><p>What can we learn from 2000 generations of welcome? | Mickey O`Brien | TEDxAdelaide<br/><a target="_blank" href="https://youtu.be/G4mEF3zRwL4">https://youtu.be/G4mEF3zRwL4</a></p><p>Celebrating Diversity presented by Australia Post: Mickey O`Brien<br/><a target="_blank" href="https://youtu.be/RYptSrohFcE">https://youtu.be/RYptSrohFcE</a></p></small>'
        },
        {
          name: "Katrina Karlapina Power",
          photo: "katrina_power.jpg",
          services: [
            "Welcome to Country",
            "Smoking Ceremony",
            "Cross-Cultural Consultancy",
            "Cultural Education",
            "Narrative Therapy",
            "Aboriginal Artist",
            "Traditional Clothing"
          ],
          local: true,
          contactNumbers: ["0481 294234"],
          email: "karlapina50@hotmail.com",
          website: null,
          descriptionModal: false,
          description:
            "<p>Karlapina, which means Lover of Fire, Katrina is a proud Kaurna journalist and a well accomplished Kaurna woman who is a mother and a grandmother, who is adapt in narrative therapy and cross-cultural consultancy.</p><br/><blockquote><p><q>Kaurna Warra Tirka`dlu. Here’s the segment you`ve all been waiting for – Kaurna Warra Tirka`dlu - Let’s learn the Kaurna language.</q></p></blockquote><br/>"
        },
        {
          name: "Frank Wangutya Wanganeen",
          photo: "frank_wanganeen.jpg",
          services: ["Welcome to Country", "Cultural Tours"],
          local: false,
          contactNumbers: ["0457 316850"],
          email: "frank.wanganeen@gmail.com",
          website: null,
          descriptionModal: false,
          description:
            "<p>Frank Wangutya Wanganeen is a Kaurna / Nurungga Man who was raised on Point Pearce Mission on the Yorke Peninsular of South Australia.</p><p>He is passionate about Reconciliation and has been on involved in various committees that deal with Reconciliation.</p><p>He has been on the Adelaide City Council Reconciliation Committee, Campbelltown Reconciliation Committee, and Salisbury RAP Committee Aboriginal Heritage, Native Title, Social Justice and the Revival of the Kaurna Language.</p><p>Frank also conducts Kaurna Cultural Tours in the Adelaide CBD and surrounding areas where he creates awareness regarding Kaurna Cultural Heritage and raises the awareness about Aboriginal issues.</p><p>Frank is the 2017 recipient of the Premier`s NAIDOC Award which he received for his contribution and ongoing work in the area of the revival of the Kaurna Language, Aboriginal Heritage, Native Title, and community engagement. </p><br/><blockquote><p><q>I like to reflect on shared histories and on the contributions of Kaurna culture.</q></p></blockquote><br/>"
        },
        {
          name: "Rodney O`Brien",
          photo: "rod_obrien.jpg",
          services: ["Welcome to Country"],
          local: true,
          contactNumbers: ["0410 577445"],
          email: "rod.obrien@adelaide.edu.au",
          website: null,
          descriptionModal: false,
          description:
            "<p>Rod, as he likes to be called, has been an active member of the Kaurna and Port Adelaide Aboriginal community for many years as a member and as a Chairperson on a number of committees which include the Kaurna Warra Karrpanthi, Kaurna Yerta Aboriginal Corporation and Kura Yerlo Inc.</p><p>Rod has done Kaurna Welcome to Country for over 20 years and is proud to be involved in the revival of the Kaurna language and the practice of maintaining Kaurna cultural protocols.</p><br/><blockquote><p><q>My dream is to see Kaurna language and culture be taught in every school in the Adelaide plains region, become a reality in the not too distant future.</q></p></blockquote><br/>"
        },
        {
          name: "Lynette Alice Crocker",
          photo: "lynette_crocker.jpg",
          services: [
            "Welcome to Country",
            "Cross-Cultural Consultancy",
            "Cultural Education"
          ],
          local: false,
          contactNumbers: ["0468 349510"],
          email: "crockerlynette@gmail.com",
          website: null,
          descriptionModal: false,
          description:
            '<p>Lynette Alice Crocker (nee Smith) - Ngangki Burka, Senior Kaurna Woman.</p><p>Lynette`s passion at this time is Community Development in particular the wellbeing of our mother earth and the wellbeing of her people, whilst her focus is; the true telling of the history of our space and place and our position in the universe.</p><p>Who is:</p><ul class="bulleted" style="font-size: .8em;"><li>a Kaurna Aboriginal Title holder, Traditional Owner;</li><li>Kowiandilla Meyunna - Kua Nepotinna (Lone Crow);</li><li>Foundation Member of the Kaurna Elders Assembly;</li><li>Member of the Aboriginal State Advisory Committee (Natural Resources) – ASAC;</li><li>Tarndanya and Mika Womma Yerta;</li><li>Vice Chair of the Kaurna Yerta Aboriginal Corporation (Native Title);</li><li>Named Applicant Kaurna Native Title Claim / Apical Ancestor Group (Nellie Reminemn AKA Mary Monarto);</li><li>Inaugurating Kua Nepotinna Constituent Founder - Kaurna Elders Assembly;</li><li>Vice-Chair of the Kaurna Nation Cultural Heritage Association (KNCHA);</li><li>Board member (Publicity Officer) of the Multicultural Writers Association of Australia (Inc);</li><li>Management Committee member of the Roma Mitchell Community Legal Centre Inc.;</li><li>Treasurer - Journey of Healing Assoc. (S.A.) Inc;</li><li>Treasurer – Australians for Native Title and Reconciliation (ANTaR) SA Inc., National Delegate ANTaR Australia;</li><li>Adelaide City Council – Reconciliation Committee member;</li><li>Australian Institute of Landscape Architects – member;</li><li>Chair National Aboriginal Education Consolidation Group - putting in place the Aboriginal Education policy across sectors of education including Higher education, TAFE, Community Education and Early Childhood Education.</li></ul><br/><blockquote><p><q>Within that journey of life, there are many pathways people take.; a pathway to reconciliation, a pathway to education, a pathway to discovery about history, a pathway of discovery about our parks, wildlife and nature.  As human beings what is important to us is our culture, our language, our traditions and our spirituality.<br/>Our connection to the land that sustains us as it always has.  It steers and drives us along with our shared knowledge and the knowledge passed down to us by our ancestors</q></p></blockquote><br/>'
        },
        {
          name: "Aunty Heather Agius",
          photo: "heather_agius.jpg",
          services: ["Welcome to Country"],
          local: false,
          contactNumbers: ["0422 212 288"],
          email: "",
          website: null,
          descriptionModal: false,
          description:
            "<p>Aunty Heather Agius is Kaurna Elder born and raised in Adelaide.</p><p>Aunty Heather is an advocate for Aboriginal rights and was awarded the NAIDOC Elder of the Year award in 2017. She is also an elder with South Australian Prisons program and a Court Elder in the Magistrates/District Court, with many years` experience working in the social justice and criminal justice.</p><p>She is very community oriented and has been a member of the Grannies Group since 1999.</p><br/><blockquote><p><q>My connection to my Kaurna culture has become stronger because of my strong connection to my family, especially to my Elders; they need to be given credit. Without our family passing on our culture and knowledge we wouldn`t know what we are and who we are today.</q></p></blockquote><br/>"
        },
        {
          name: "Jack Kanya Buckskin",
          photo: "jack_buckskin.jpg",
          services: [
            "Welcome to Country",
            "Cross-Cultural Consultancy",
            "Cultural Education",
            "Cultural Dance",
            "Didgeridoo",
            "Cultural Tours",
            "Traditional Clothing",
            "Smoking Ceremony"
          ],
          local: true,
          contactNumbers: ["(08) 8240 0300"],
          email: "kumakaaru@outlook.com",
          website: null,
          descriptionModal: false,
          description:
            "<p>Jack Kanya Buckskin is a Kaurna man born in Adelaide, who is a trailblazer for the reclamation and revitalisation of the Kaurna language who is the Kaurna Language Coordinator and Teacher and Cultural Educator at Tauondi College.</p><p>Jack founded the Adelaide based Kuma Kaaru Cultural Services which works to educate and share culture through song, dance and workshops.</p><br/><blockquote><p><q>My mission is to teach the Kaurna language, the language of my ancestors, to as many people as I can in my lifetime.</q></p></blockquote><br/>"
        },
        {
          name: "Les Wanganeen",
          photo: "les_wanganeen.jpg",
          services: ["Welcome to Country", "Cross-Cultural Consultancy"],
          local: true,
          contactNumbers: ["0438 967536"],
          email: "lwanganeen@centacare.org.au",
          website: null,
          descriptionModal: false,
          description:
            "<p>Les Wanganeen a Narungga Kaurna man born at Wallaroo on the Yorke Peninsula.</p><p>Les lived on Point Pearce Station/Mission and, as a result of the 1967 Referendum his family moved to Adelaide into the western suburbs. Les attended primary and high school in the western region with his cousins and various other Aboriginal children and young people.</p><p>Les has a South Australian Institute of Technology (SAIT) Associated Diploma in Aboriginal & Torres Strait Islander Administration, Flinders University SA Batchelor of Arts Degree and Master’s Degree in Aboriginal Social Policies and, worked in the educational, justice and child protection sector in Government and non-Government organisations from operation to middle and higher management.</p><p>Les has lived in Northern Territory, Sydney but has always returned back to South Australia (in the western region). Les did work as a tour guide with Kevin O’Loughlin in Adelaide focusing of the Kaurna culture, flora, and fauna and dreaming stories and is attempting to learn the Kaurna language.</p><p>Les is happy to do the Kaurna welcome in language and speak about the struggles of Aboriginal people historically and contemporary in the Adelaide western area and in Australia.</p>"
        },
        {
          name: "Kaurna Warra Karrpanthi",
          photo: "kwk.jpg",
          services: ["Kaurna Language"],
          local: false,
          contactNumbers: ["(08) 8240 0300"],
          email: "admin@kwk.org.au",
          website: "https://www.adelaide.edu.au/kwp/kwk/",
          descriptionModal: false,
          description:
            '<p>If you want to know more about Kaurna language a course titled ‘Reclaiming Languages; a Kaurna case study’ is taught at the University of Adelaide.Certificate lll in Learning Kaurna and Certificate lV in Teaching Kaurna also, a conversational Kaurna language class will be offered and open to allpeople at Tauondi Aboriginal College, 1 Lipson St Port Adelaide. For further information contact details are below:</p><p><strong>Kaurna Warra Karrpanthi (KWK)</strong></p><ul><li>Taylor Power-Smith</li><li><a href="mailto:admin@kwk.org.au">admin@kwk.org.au</a></li><li><a href="mailto:taylor.power-smith@hotmail.com">taylor.power-smith@hotmail.com</a></li></ul><p><strong>Linguistics, University of Adelaide (KWP)</strong></p><ul><li>Dr Rob Amery</li><li>(08) 8303 3924</li><li><a href="mailto:robert.amery@adelaide.edu.au">robert.amery@adelaide.edu.au</a></li><li><a href="mailto:kwp@adelaide.edu.au">kwp@adelaide.edu.au</a></li></ul>'
        }
      ]
    };
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/community/atsi/KaurnaRegister.vue